import React from 'react';
import { mdiStore } from '@mdi/js';
import Icon from '@mdi/react';
import { MarketBorder, MarketHeader, MarketIconContainer, MarketplaceContentContainer, MarketTextOverLine, MarketTitle, MarketTitleContainer } from './styles';
export { MarketplaceStat, StatTypes } from './MarketPlacestat';
export { TenantMarketplaceCard } from './TenantMarketplaceCard';
export const Marketplace = ({ children }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(MarketHeader, null,
            React.createElement(MarketBorder, null,
                React.createElement(MarketIconContainer, null,
                    React.createElement(Icon, { path: mdiStore })),
                React.createElement(MarketTitleContainer, null,
                    React.createElement(MarketTextOverLine, null, "Adept Learning Platforms"),
                    React.createElement(MarketTitle, null, "Organizations")))),
        React.createElement(MarketplaceContentContainer, null, children)));
};
//# sourceMappingURL=index.js.map